import React from "react";
import "./../../styles/columns.css";
import { Spring } from "react-spring/renderprops";
import Bande from '../svg/Bande';
import { colors, bandeDelay, bandeTranslationCount } from './../../components/common/Constants';

class LeftColumn extends React.Component {
  constructor(props) {
    super(props);

    this.state = { colors, n:0 };

    switch (props.page) {
      case "programmation":
        this.design = "leftDesignLessons";
        break;
      default:
        this.design = "leftDesignTT";
    }

    this.anim = this.anim.bind(this);
    this.sto = setTimeout(this.anim, bandeDelay);
  }

  anim() {
    let colrs = this.state.colors;
    let ns = this.state.n + 1;
    const firstColor = colrs.shift();
    colrs.push(firstColor);

    this.setState({colors:colrs, n:ns}, () => { 
      if (this.state.n < bandeTranslationCount)
      this.sto = setTimeout(this.anim, bandeDelay);
    })
  }

  render() {
    if (this.design === "leftDesignTT") {
      let colrs = this.state.colors;
      let loop = this.props.loops || 0;
      if (this.props.n && !this.props.popupOpened) {
        for(let i = 0; i < this.props.n; i++) colrs = colrs.concat(this.state.colors);
      }

      return (
        <Spring from={{ opacity: 0 }} to={{ opacity: 1 }}>
          {props => (
            <div className="leftColumn">
              <Bande pos={this.props.pos} colors={colrs}/>
            </div> 
          )}
        </Spring>
      )}
      else return (    
      <Spring from={{ opacity: 0 }} to={{ opacity: 1 }}>
      {props => (
        <div className="leftColumn" style={props}>
          <div className={this.design}></div>
        </div> 
      )}
    </Spring>)
  }

  componentWillUnmount() {
    if (this.sto) clearTimeout(this.sto);
  }
}

export default LeftColumn;
